const sendMail = (name, mail, subject, message) => {
  const to = 'rawslcontact@gmail.com';
  const body = [
    `Name: ${name}`,
    `Email: ${mail}`,
    '',
    message
  ].join('\n');

  const url = `mailto:${encodeURIComponent(to)}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  window.location.href = url;
};

export default sendMail;
